export default "__VITE_ASSET__DCZGCnj4__"